<form
  [formGroup]="agent_builder_form_group"
  class="hmn-form__standalone hmn-row__space hmn-wrap">
  <mat-form-field
    class="hmn-width__half-x2 hmn-form-field__primary"
    appearance="fill"
    color="accent">
    <mat-label> {{ 'GENERAL.FIRSTNAME_LABEL' | translate }} </mat-label>
    <input
      matInput
      type="text"
      formControlName="firstname"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <mat-form-field
    class="hmn-width__half-x2 hmn-form-field__primary"
    appearance="fill"
    color="accent">
    <mat-label> {{ 'GENERAL.LASTNAME_LABEL' | translate }} </mat-label>
    <input
      matInput
      type="text"
      formControlName="lastname"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <mat-form-field
    class="hmn-width__full hmn-form-field__primary"
    appearance="fill"
    color="accent">
    <mat-label> {{ 'GENERAL.EMAIL_LABEL' | translate }} </mat-label>
    <input
      matInput
      type="email"
      formControlName="email"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <mat-form-field
    class="hmn-width__1-4-x2 hmn-form-field__primary"
    appearance="fill"
    color="accent">
    <mat-label> {{ 'GENERAL.PHONE_PREFIX_LABEL' | translate }} </mat-label>
    <input
      matInput
      type="text"
      formControlName="phone_prefix"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <mat-form-field
    class="hmn-width__3-4-x2 hmn-form-field__primary"
    appearance="fill"
    color="accent">
    <mat-label> {{ 'GENERAL.PHONE_VALUE_LABEL' | translate }} </mat-label>
    <input
      matInput
      type="text"
      formControlName="phone_value"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <app-shared-button
    class="hmn-margin__x6-top hmn-display__block hmn-width__full"
    [button_cta]="'GENERAL.CONFIRM_CTA'"
    [button_class]="'hmn-button__main hmn-width__full'"
    [button_cta_class]="'hmn-text__5'"
    (button_click)="onConfirmClick()"></app-shared-button>
</form>
